export function parseNumber(numStr) {
    var float = parseFloat(numStr.replace(",", "."));
    return Math.max(0, float.toString() === 'NaN' ? 0 : float);
}



//////////////////
// WEBPACK FOOTER
// ./src/utils/parsing.ts
// module id = 115
// module chunks = 0